// extracted by mini-css-extract-plugin
export var linkText = "_pw-0";